import React from "react";
import { DatePicker } from "antd";
import { RangePickerProps } from "antd/es/date-picker";

const { RangePicker } = DatePicker;

export default function RangePickerUI(props: RangePickerProps) {
  return <RangePicker {...props} />;
}
